import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "./redux/totalVisitsSagas";
import PropTypes from "prop-types";

import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import TableOrStackedBarChart from "./smartComponents/tableOrStackedBarChart";
import KBLearnMore from "../../../components/learnMore/KBLearnMore";
import { ILEARN_URLS } from "../../../constants/ilearnUrls";
import CustomDateRanges from "./smartComponents/customDateRanges";
import PeriodType from "./smartComponents/periodType";
import DatePicker from "./smartComponents/datePicker";
import { CrossClubFilter } from "./smartComponents/crossClubFilter";
import { GroupByFilter } from "./smartComponents/groupByFilter";
import { DataPoints } from "./smartComponents/dataPoints";

import "../attendance_common.css.scss";

const TotalVisitsModule = (props) => {
  const dispatch = useDispatch();
  const {
    isLoading,
    initialRequest,
    updatesLoading,
    filtersDirty,
    startDate,
    endDate,
    currentUser: { clientName = "" }
  } = useSelector((state) => state.totalVisits);

  useEffect(() => {
    if (!initialRequest) {
      dispatch(actionCreators.fetchCurrentUser(props));
    }
  }, []);

  const renderUpdateBtn = () => {
    let checkForInvalidDate = startDate !== "Invalid date" && endDate !== "Invalid date";
    if (filtersDirty && !isLoading && checkForInvalidDate) {
      return (
        <button className="submit" onClick={() => dispatch(actionCreators.updateData())}>
          Update
        </button>
      );
    }
  };

  const renderResetBtn = () => {
    if (filtersDirty && !isLoading) {
      return (
        <button className="submit reset" onClick={() => dispatch(actionCreators.resetFilters())}>
          Reset
        </button>
      );
    }
  };

  const content = () => {
    return (
      <div>
        <div id="override-edit-selection-bar" className="edit-selections-bar">
          <div className="top-filter">
            <div>
              <div className="select-box-no-width" style={{ flex: "none", width: "125px" }}>
                <p>Cross Club</p>
                <CrossClubFilter />
              </div>

              <div className="select-box-no-width" style={{ width: "210px" }}>
                <p>Group By</p>
                <GroupByFilter />
              </div>
            </div>

            <div className="top-filter__right">
              <div className="select-box-no-width">
                <p>Period Type</p>
                <PeriodType />
              </div>

              <div className="select-box-no-width date-range-select-box">
                <p>Date Range</p>
                <CustomDateRanges />
              </div>

              <div className="date-select-box select-box-no-width multi">
                <p>Date</p>
                <DatePicker />
              </div>
              {renderUpdateBtn()}
              {renderResetBtn()}
            </div>
          </div>
        </div>

        <div className="chart-root">
          {updatesLoading ? (
            <LoadingAnimation text="Updating data..." />
          ) : (
            <>
              <DataPoints />
              <TableOrStackedBarChart />
            </>
          )}
        </div>
      </div>
    );
  };

  return (
    <div id="attendance-root">
      <SectionToggle
        autoHeight
        height={690}
        title="Total Visits"
        isLoading={isLoading}
        content={content()}
        learnMore={<KBLearnMore {...learnMoreProps(clientName)} />}
      />
    </div>
  );
};

const learnMoreProps = (clientName) => {
  const name = clientName?.toLowerCase();
  return {
    title: "Total Visits",
    description: `This report shows the total number of member visits logged during the selected period. These insights help you evaluate overall traffic volume, monitor engagement patterns, and measure how frequently ${name} use your facility.`,
    kbUrl: ILEARN_URLS.attendance.totalVisits,
    customStyles: { width: "510px" }
  };
};

export default React.memo(TotalVisitsModule);

TotalVisitsModule.propTypes = {
  params: PropTypes.object,
  clientName: PropTypes.string,
  isLoading: PropTypes.bool,
  filtersDirty: PropTypes.bool,
  updatesLoading: PropTypes.bool,
  updateChart: PropTypes.func,
  resetFilters: PropTypes.func,
  compareDates: PropTypes.bool,
  startDate: PropTypes.string,
  endDate: PropTypes.string
};
